import React from 'react';
import classNames from 'classnames';
import { required, requiredFieldArrayCheckbox } from '../../util/validators';
import { regionOptions, countryOptions, usaStates } from '../../util/countryOptions';
import { FieldTextInput, FieldCheckboxGroup } from '../../components';
import css from './FullLocationInputs.module.css';

const FullLocationInputs = (props) => {
    const {
        showNonRegions,
        showCityField,
        fieldClassname,
        values = {},
        form,
        requireEveryField,
        showStateAllOption,
    } = props;

    const {
        region = [],
        country = [],
        state = [],
    } = values;

    const allRegionOptions = [
        ...(showNonRegions ? [
            { value: "global", label: "Global" },
            { value: "notApplicable", label: "Not Applicable" },
        ] : []),
        ...regionOptions,
    ];

    const availableCountries = region && region.length > 0
        ? countryOptions.filter(c => region.includes(c.region))
        : [];

    const selectedRegionsLength = Array.isArray(region)
        ? region.length
        : 0;
    const selectedCountriesLength = Array.isArray(country)
        ? country.length
        : 0;
    const selectedStatesLength = Array.isArray(state)
        ? state.length
        : 0;

    const stateOptionsWithAllMaybe = [
        ...(showStateAllOption ? [{ key: "any", label: "All" }] : []),
        ...usaStates.map(o => {
            return {
                key: o.value,
                label: o.label,
            }
        }),
    ].filter(v => v);

    const optionalLabelMaybe = requireEveryField ? "" : " {optional}";

    return <div>
        <FieldCheckboxGroup
            id="region"
            name="region"
            className={classNames(fieldClassname, css.horizentalScroll)}
            label={`Region (${selectedRegionsLength} selected)`}
            options={allRegionOptions.map(o => {
                const optionDisabled = region.includes("notApplicable") && o.value !== "notApplicable";
                return {
                    key: o.value,
                    label: o.label,
                    disabled: optionDisabled,
                }
            })}
            validate={requiredFieldArrayCheckbox("Required")}
            onChange={() => {
                form.batch(() => {
                    form.change("country", []);
                    form.change("state", []);

                    const newRegions = form.getState().values.region || [];
                    if (newRegions.length > 1 && newRegions.includes("notApplicable")) {
                        form.change("region", ["notApplicable"]);
                    };
                });
            }}
        />

        {availableCountries.length > 0 ? <FieldCheckboxGroup
            id="country"
            name="country"
            className={classNames(fieldClassname, css.horizentalScroll)}
            label={`Country${optionalLabelMaybe} (${selectedCountriesLength} selected)`}
            options={availableCountries
                .map(o => {
                    return {
                        key: o.value,
                        label: o.label,
                    }
                })
                .sort((a, b) => {
                    return a.label.localeCompare(b.label);
                })
            }
            validate={requireEveryField ? requiredFieldArrayCheckbox("Required") : () => undefined}
            onChange={() => {
                form.change("state", []);
            }}
            useAllButton={true}
            onSelectAll={() => {
                form.batch(() => {
                    form.change("country", availableCountries.map(o => o.value));
                    form.change("state", []);
                });
            }}
        /> : null}

        {country && country.includes("unitedStates") ? <FieldCheckboxGroup
            id="state"
            name="state"
            className={classNames(fieldClassname, css.horizentalScroll)}
            label={`State${optionalLabelMaybe} (${selectedStatesLength} selected)`}
            options={stateOptionsWithAllMaybe}
            validate={requireEveryField ? requiredFieldArrayCheckbox("Required") : () => undefined}
        /> : null}

        {showCityField ? <FieldTextInput
            id="city"
            name="city"
            className={fieldClassname}
            type="text"
            label="City"
            placeholder="Enter city"
            validate={required("Required")}
        /> : null}
    </div>
};

export default FullLocationInputs;
